import { useInView } from 'react-intersection-observer'
import React, { useState, useEffect, useCallback } from 'react'

export default function Accordion (props) {
  const renderSection = items =>
    items.map(items => {
      const accordions = items.accordions
      const [slideUpRef, isInView] = useInView({ triggerOnce: true })

      return (
        <React.Fragment key={items.faq_sectionname}>
          <div className='row accordions '>
            <div className='col-12 col-lg-10 offset-lg-1'>
              <h2
                ref={slideUpRef}
                className={`faq-heading animation ${
                  isInView ? 'logo-slide-up' : ''
                }`}
                dangerouslySetInnerHTML={{ __html: items.faq_sectionname }}
              />

              {renderAccordion(accordions)}
            </div>
          </div>
          <style jsx>{`
            h2 {
              margin-bottom: 50px;
            }
          `}</style>
        </React.Fragment>
      )
    })

  const renderAccordion = childItems =>
    childItems.map(items => {
      const [slideUpRef, isInView] = useInView({ triggerOnce: true })
      const [active, setActive] = useState(false)

      return (
        <React.Fragment key={items.accordion_heading}>
          <div
            ref={slideUpRef}
            className={`accordion animation ${isInView ? 'logo-slide-up' : ''}`}
          >
            <section>
              <h2
                role='tab'
                tabIndex='0'
                aria-controls='content-1'
                aria-expanded={`${active ? 'true' : 'false'}`}
                id='accordion-control-1'
                onClick={() => setActive(!active)}
                className={`p-body accordion-control ${active ? 'active' : ''}`}
              >
                <div
                  dangerouslySetInnerHTML={{ __html: items.accordion_heading }}
                />

                <div className='read-more-icon'>
                  <span></span>
                  <span></span>
                </div>
              </h2>
              <div
                className={`content ${active ? 'active' : ''}`}
                id='content-1'
                dangerouslySetInnerHTML={{ __html: items.accordion_content }}
              />
            </section>
          </div>
          <style jsx>{`
            .content {
              display: block;
              visibility: hidden;
              opacity: 0;
              max-height: 0px;
              margin-top: 0px;
            }
            .content.active {
              max-height: 1000px;
              visibility: visible;
              margin-top: 30px;
              opacity: 1;
            }
          `}</style>
        </React.Fragment>
      )
    })
  return <React.Fragment>{renderSection(props.section)}</React.Fragment>
}
